















import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  name: 'CampaignLayout',

  middleware: [
    'errorRouteGuard',
    'authGuard',
    'hubspot',
    'hotjar',
    'accountSetupGuard'
  ],

  mounted() {
    this.$intercom.syncUser();
    this.$pushToStateListener.listen();
    if (!this.newCampaign) this.$activityTracking.track('campaignViewedAt');
  },

  computed: {
    newCampaign() {
      return (
        this.$route.name === 'campaigns-name' ||
        this.$route.name === 'campaigns-new' ||
        this.$route.name === 'campaigns-objective'
      );
    },
    ...mapState('user', ['overrideMobileWarning'])
  }
});
